import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import HardwareProductsPage from "@/pages/products/HardwareProductsPage";

export const Route = createFileRoute("/products/hardware")({
  head: () => pageHead("Enterprise Hardware & Devices", "Business laptops, desktops, mobile workstations, and enterprise networking hardware supplied and configured for productivity across your organization.", "/products/hardware", false),
  component: HardwareProductsPage,
});
